export const MAX_RANGE_DAYS = 90;
